import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "titlecaseexcept"
})
export class TitleCaseExceptPipe implements PipeTransform {
  transform(value: string): string {
    if (value) {
      if (value == "qa1" || value == "Qa1") {
        return "QA1";
      }
      let words = value.split(" ") as any;

      for (let i = 0; i < words.length; i++) {
        words[i] = words[i][0].toUpperCase() + words[i].substr(1);
      }
      words = words.join(" ");
      return words;
    } else {
      return value;
    }
  }
}
